package devxertech.com.style

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.silk.style.animation.Keyframes
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vw

val SpinOnce = Keyframes {
    from { Modifier.transform { rotate(0.deg) } }
    to { Modifier.transform { rotate(360.deg) } }
}

val RatingRow = Keyframes {
    from { Modifier.transform { translateX(0.percent) }}
    to {  Modifier.transform { translateX(((-100).vw)) }}
}

val ShiftRight1 = Keyframes {
    from { Modifier.left(0.px) }
    to { Modifier.left(200.px) }
}